import React from 'react';
import classNames from 'classnames';
import BusComponent from '../BusComponent';
import TabbedBrowser from '../tabbedBrowser/TabbedBrowser';
import GeocodeOptions from './GeocodeOptions';
import LatLongOptions from './LatLongOptions';
import Panel from '../panel/Panel';
import {injectIntl} from "react-intl";

class LatLongAndGeocodeOptions extends BusComponent {
    constructor(props, context) {
        super(props, context);
        this.state = { selectedTabIndex: 0 };
    }

    static componentName() {
        return 'LAT_LONG_GEOCODE_OPTIONS';
    }

    onTabChange = selectedTabIndex => {
        this.setState({ selectedTabIndex });
    };

    render() {
        const { error, mapInstanceId, onBack, selection, userUpload, intl } = this.props;
        const { selectedTabIndex } = this.state;

        const availableTabs = [
            { name: 'Lat & Long' },
            { name: 'Geocode' },
        ];
        const tabs = [
            <LatLongOptions
                key="lat-long"
                mapInstanceId={mapInstanceId}
                selection={selection}
                userUpload={userUpload}
                error={error}
                onBack={onBack}
            />,
            <GeocodeOptions
                key="geocode"
                mapInstanceId={mapInstanceId}
                selection={selection}
                userUpload={userUpload}
                error={error}
                onBack={onBack}
            />,
        ];
        return (
            <div className="user-data-upload-editor user-data-upload-editor--latlong">
                <Panel
                    title={intl.formatMessage({ id: 'dataBrowser.chooseColumnsToPositionYourPlacemarks' })}
                    headerStyle="white"
                    onBackClick={onBack}
                >
                    <TabbedBrowser
                        className="user-data-upload-editor__tabs"
                        tabNames={availableTabs}
                        tabSwitchedCallback={this.onTabChange}
                        selectedTabIndex={selectedTabIndex}
                    >
                        {tabs}
                    </TabbedBrowser>
                </Panel>
            </div>
        );
    }
}

export default injectIntl(LatLongAndGeocodeOptions);
